export function injectMaterialsAndMethodsIntoAttributes(exam) {
	const materials = exam.body?.materials || []
	const methods = exam.body?.methods || []

	// Encontrar o primeiro attribute_group do exame (ou criar um novo se necessário)
	let firstAttributeGroup = exam.body?.result?.result_data?.attribute_groups?.[0]

	if (!firstAttributeGroup) {
		firstAttributeGroup = {
			uuid: crypto.randomUUID(),
			name: 'Geral',
			display_title: true,
			page_break: false,
			position: 1,
			attributes: [],
		}

		// Se não existir, adicionamos esse grupo ao exame
		exam.body.result.result_data.attribute_groups = [firstAttributeGroup]
	}

	// Criar os atributos de materiais e métodos
	const materialAttributes = buildAttributes(materials, 2000, 'Material')
	const methodAttributes = buildAttributes(methods, 3000, 'Método', (m) => m.nome || m.name)

	// Adicionar os novos atributos ao início do grupo existente
	firstAttributeGroup.attributes = [
		...materialAttributes,
		...methodAttributes,
		...(firstAttributeGroup.attributes || []),
	]

	return exam
}

function buildAttributes(items, baseId, labelPrefix, getLabel = (item) => item) {
	return items.map((item, index) => ({
		id: baseId + index,
		uuid: crypto.randomUUID(),
		name: `${labelPrefix}: ${getLabel(item)}`,
		type: 'text',
		position: index + 1,
		value: null,
		show_in_report: true,
		show_title_result: false,
		is_mandatory: true,
		page_break: false,
		reference_attribute_id: null,
		reference_values: [],
		default_value: '',
		description: '',
		display_method: 0,
		method: '',
		note: '',
		options: [],
		select_options: [],
	}))
}
